function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "EDB61170-64CE-44CA-83D3-1C722F6160DF@1.00x");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 417,
  height: 271,
  rx: 5
}), React.createElement("filter", {
  x: "-6.1%",
  y: "-8.3%",
  width: "112.2%",
  height: "119.2%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, React.createElement("feMorphology", {
  radius: 1,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dx: 0,
  dy: 3,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 7,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter2"
}), React.createElement("feOffset", {
  dx: 0,
  dy: 8,
  in: "shadowSpreadOuter2",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feMorphology", {
  radius: 1.5,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadOuter3"
}), React.createElement("feOffset", {
  dx: 0,
  dy: 5,
  in: "shadowSpreadOuter3",
  result: "shadowOffsetOuter3"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetOuter3",
  result: "shadowBlurOuter3"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
  type: "matrix",
  in: "shadowBlurOuter3",
  result: "shadowMatrixOuter3"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter3"
}))));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "2.1-Course-details",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Notification---Graded-attendance",
  transform: "translate(-46.000000, -83.000000)"
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(10.000000, 10.000000)"
}, React.createElement("g", {
  id: "Rectangle-Copy"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Group-4",
  transform: "translate(23.000000, 24.000000)",
  fill: "#959595",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M101,63 C109.794267,63 117.40264,67.2773006 123.753393,75.7332578 C124.06186,76.1439785 124.082796,76.7060266 123.805757,77.1390355 C117.919171,86.3397047 110.285315,91 101,91 C91.7146849,91 84.0808289,86.3397047 78.1942428,77.1390355 C77.9172038,76.7060266 77.9381396,76.1439785 78.2466068,75.7332578 C84.5973601,67.2773006 92.2057332,63 101,63 Z M101,65.4495507 C93.541805,65.4495507 87.0188932,68.8370982 81.3729487,75.6923944 L81.3729487,75.6923944 L80.6993444,76.5288685 L81.2694822,77.3582475 C86.380415,84.6028393 92.6718802,88.2997111 100.215189,88.5381196 L100.215189,88.5381196 L101,88.5504493 C108.892822,88.5504493 115.443346,84.8526528 120.730518,77.3582475 L120.730518,77.3582475 L121.298521,76.5288685 L120.647907,75.7177376 C115.198735,69.0905841 108.932101,65.6962396 101.795516,65.4625169 L101.795516,65.4625169 Z M101.5,68 C106.19442,68 110,71.8055796 110,76.5 C110,81.1944204 106.19442,85 101.5,85 C96.8055796,85 93,81.1944204 93,76.5 C93,71.8055796 96.8055796,68 101.5,68 Z M101.5,70.4285714 C98.1468426,70.4285714 95.4285714,73.1468426 95.4285714,76.5 C95.4285714,79.8531574 98.1468426,82.5714286 101.5,82.5714286 C104.853157,82.5714286 107.571429,79.8531574 107.571429,76.5 C107.571429,73.1468426 104.853157,70.4285714 101.5,70.4285714 Z",
  id: "Combined-Shape"
}), React.createElement("path", {
  d: "M36.3814371,85.6604387 C36.8250183,85.1464478 37.6023414,85.0858954 38.1191487,85.5280684 C38.6359559,85.9716496 38.6936919,86.7503809 38.2501107,87.26578 L38.2501107,87.26578 L34.2423902,91.9269026 C34.0072218,92.2000923 33.6664388,92.3564018 33.3073493,92.3564018 L33.3073493,92.3564018 C32.9454434,92.3549936 32.6046604,92.1972759 32.3709002,91.9240862 L32.3709002,91.9240862 L29.2939959,88.3205174 C28.8532312,87.802302 28.9151917,87.0249788 29.431999,86.5828058 C29.9488062,86.1406329 30.7275376,86.2025934 31.1683024,86.7194007 L31.1683024,86.7194007 L33.3101657,89.2302108 Z M68.7225728,87.8487724 C69.6477614,87.8487724 70.397775,88.598786 70.397775,89.5239746 L70.397775,89.6940555 C70.397775,90.6192442 69.6477614,91.3692577 68.7225728,91.3692577 L45.5848453,91.3692577 C44.6596566,91.3692577 43.909643,90.6192442 43.909643,89.6940555 L43.909643,89.5239746 C43.909643,88.598786 44.6596566,87.8487724 45.5848453,87.8487724 L68.7225728,87.8487724 Z M30.0670945,74.5258475 C30.5472887,74.0442451 31.3274283,74.0442451 31.8090307,74.5258475 L31.8090307,74.5258475 L33.5340685,76.2494771 L35.2605146,74.5272557 C35.7407088,74.0456533 36.5208483,74.0470615 37.0024507,74.5272557 C37.4840531,75.0074499 37.4840531,75.7889977 37.0024507,76.2691919 L37.0024507,76.2691919 L35.2788211,77.9928215 L37.0024507,79.7178593 C37.4840531,80.1980535 37.4840531,80.9781931 37.0024507,81.4597955 C36.7630577,81.7005967 36.4476222,81.8202932 36.1321867,81.8202932 C35.8167512,81.8202932 35.5013158,81.7005967 35.2605146,81.4597955 L35.2605146,81.4597955 L33.5368849,79.7347577 L31.8118471,81.4597955 C31.5710459,81.7005967 31.2556104,81.8202932 30.9401749,81.8202932 C30.6247394,81.8202932 30.3093039,81.7005967 30.0685027,81.4597955 C29.5869003,80.9781931 29.5869003,80.1980535 30.0685027,79.7164511 L30.0685027,79.7164511 L31.7907242,77.9914133 L30.0670945,76.2677837 C29.5854921,75.7875895 29.5854921,75.0074499 30.0670945,74.5258475 Z M68.7225728,76.2325788 C69.6477614,76.2325788 70.397775,76.9825924 70.397775,77.9077811 L70.397775,78.077862 C70.397775,79.0030506 69.6477614,79.7530642 68.7225728,79.7530642 L45.5848453,79.7530642 C44.6596566,79.7530642 43.909643,79.0030506 43.909643,78.077862 L43.909643,77.9077811 C43.909643,76.9825924 44.6596566,76.2325788 45.5848453,76.2325788 L68.7225728,76.2325788 Z M36.3814371,62.4280516 C36.8250183,61.9126525 37.6023414,61.8549165 38.1191487,62.2970895 C38.6359559,62.7406707 38.6936919,63.5179938 38.2501107,64.0348011 L38.2501107,64.0348011 L34.2423902,68.6959237 C34.0072218,68.9677052 33.6664388,69.1240147 33.3073493,69.1240147 L33.3073493,69.1240147 C32.9454434,69.1240147 32.6046604,68.9648888 32.3709002,68.6916991 L32.3709002,68.6916991 L29.2939959,65.0881303 C28.8532312,64.5699149 28.9151917,63.7925917 29.431999,63.3504187 C29.9502144,62.909654 30.7275376,62.9716145 31.1697105,63.4884218 L31.1697105,63.4884218 L33.3115738,65.9978237 Z M68.7225728,64.6163853 C69.6477614,64.6163853 70.397775,65.3663989 70.397775,66.2915875 L70.397775,66.4616684 C70.397775,67.3868571 69.6477614,68.1368706 68.7225728,68.1368706 L45.5848453,68.1368706 C44.6596566,68.1368706 43.909643,67.3868571 43.909643,66.4616684 L43.909643,66.2915875 C43.909643,65.3663989 44.6596566,64.6163853 45.5848453,64.6163853 L68.7225728,64.6163853 Z",
  id: "Combined-Shape"
})))));

var SvgGradedAttendanceVisible = function SvgGradedAttendanceVisible(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "129px",
    height: "59px",
    viewBox: "0 0 129 59",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGradedAttendanceVisible, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/graded-attendance-visible.2c2eb28f.svg";
export { ForwardRef as ReactComponent };